import { Link } from "react-router-dom";
import styled from "styled-components";
import StoreCard from "../cards/StoreCard";
import CouponCard from "../cards/CouponCard";
import { cPath } from "../../constants";

const Section = styled.section`
  margin-bottom: 2.5rem;
`;

const H2 = styled.h2`
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0 0 1rem;
  color: hsl(${({ theme }) => theme.colors.foreground});
`;

const StoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  @media (min-width: 640px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

const CatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  @media (min-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const CatCard = styled(Link)`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  overflow: hidden;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.cardMd};
  }
`;

const CatImg = styled.div`
  aspect-ratio: 16 / 9;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
  }
  ${CatCard}:hover & img {
    transform: scale(1.05);
  }
`;

const CatBody = styled.div`
  padding: 0.75rem;
`;

const CatTitle = styled.h3`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
  ${CatCard}:hover & {
    color: hsl(${({ theme }) => theme.colors.primary});
  }
`;

const CatDesc = styled.p`
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CouponList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export default function SearchResultsSections({
  matchedStores,
  matchedCategories,
  matchedCoupons,
}) {
  return (
    <>
      {matchedStores.length > 0 && (
        <Section>
          <H2>Stores ({matchedStores.length})</H2>
          <StoreGrid>
            {matchedStores.slice(0, 12).map((store) => (
              <StoreCard key={store.id} store={store} />
            ))}
          </StoreGrid>
        </Section>
      )}
      {matchedCategories.length > 0 && (
        <Section>
          <H2>Categories ({matchedCategories.length})</H2>
          <CatGrid>
            {matchedCategories.slice(0, 8).map((cat) => (
              <CatCard key={cat.slug} to={cPath(`category/${cat.slug}`)}>
                <CatImg>
                  <img src={cat.image} alt={cat.name} loading="lazy" />
                </CatImg>
                <CatBody>
                  <CatTitle>{cat.name}</CatTitle>
                  <CatDesc>{cat.description}</CatDesc>
                </CatBody>
              </CatCard>
            ))}
          </CatGrid>
        </Section>
      )}
      {matchedCoupons.length > 0 && (
        <Section>
          <H2>Coupons & Deals ({matchedCoupons.length})</H2>
          <CouponList>
            {matchedCoupons.slice(0, 10).map((coupon) => (
              <CouponCard key={coupon.id} coupon={coupon} />
            ))}
          </CouponList>
        </Section>
      )}
    </>
  );
}
